function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { formatDate, formatPrice } from "@common/services/helpers";
var InvoiceInformationCard = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(InvoiceInformationCard, Component);
    var _super = _create_super(InvoiceInformationCard);
    function InvoiceInformationCard() {
        _class_call_check(this, InvoiceInformationCard);
        return _super.apply(this, arguments);
    }
    _create_class(InvoiceInformationCard, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, i18n = _this_props.i18n, getInvoiceUrl = _this_props.getInvoiceUrl, invoice = _this_props.invoice;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "invoice-card",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "clearfix invoice-card-item",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-left",
                                    children: i18n.account.date
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-right",
                                    children: formatDate(invoice.paidAt)
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "clearfix invoice-card-item",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-left",
                                    children: i18n.account.sum
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-right",
                                    children: formatPrice(invoice.amountPaid, invoice.currencyCode)
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "clearfix invoice-card-item",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-left",
                                    children: i18n.account.correction
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-right",
                                    children: invoice.amountAdjusted ? formatPrice(invoice.amountAdjusted, invoice.currencyCode) : "––"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "clearfix invoice-card-item",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-left",
                                    children: i18n.account.credits
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-right",
                                    children: formatPrice(invoice.creditsApplied, invoice.currencyCode)
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "clearfix invoice-card-item total",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-left",
                                    children: i18n.common.total
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "float-right",
                                    children: formatPrice(invoice.total, invoice.currencyCode)
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("hr", {}),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "pointer invoice-download-button",
                            onClick: function() {
                                return getInvoiceUrl(invoice.id);
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "icon icon-pdf",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "path1"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "path2"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "path3"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "path4"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: i18n.account.downloadInvoice
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return InvoiceInformationCard;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n;
    return {
        i18n: i18n
    };
};
export default connect(mapStateToProps)(InvoiceInformationCard);
